import React from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";

import Button from "../Nano/Buttons/Button.js";
import Spinner from "../Nano/Spinner.js";
import Type from "../Global/Typography.js";
import AddToPlaylistModal from "../Micro/AddToPlaylistModal.js";
import CreatePlaylistModal from "../Micro/CreatePlaylistModal.js";

import { ReactComponent as Playlist } from "../Global/Icons/playlist.svg";
import BaseComponent from "../BaseComponent";

const multiple = nota.global.multiple;

const PlaylistModalStyle = styled.div`
  width: 350px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${multiple * 3 + "px"};
  .headerModal {
    padding-bottom: ${multiple + "px"};
    border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
    svg {
      height: 16px;
      width: 16px;
      path {
        fill: ${nota.color.main.default};
      }
    }
    h3 {
      margin-left: ${multiple + "px"};
      text-transform: uppercase;
      b {
        color: ${nota.color.main.default};
      }
    }
  }
  .modalContainer {
    .modalWrapper {
      padding: ${multiple * 3 + "px"} 0;
    }
  }

  .modalBtnWrapper {
    margin-bottom: ${multiple * 2 + "px"};
    padding: ${multiple + "px"};
    background-color: ${nota.color.main.default};
    cursor: pointer;
    h4 {
      color: ${nota.color.neutral.white};
      text-transform: uppercase;
    }
    &:hover {
      opacity: 0.7;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .btnsContainer {
    padding: 16px 8px 0 8px;
    border-top: 0.5px solid ${nota.color.neutral.NeuFour};
  }

  .dropDownWrapper {
    .dropdown-content {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    width: 90vw;
  }
`;

class PlaylistModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      loading: true,
      selectedPlaylists: this.props.selectedPlaylists ? this.props.selectedPlaylists : [],
      canAddToPlaylist: true,
      openAddToPlaylist: false,
      openCreateNewPlaylist: false,
    };
  };

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedPlaylists !== this.props.selectedPlaylists) {
      this.setState({ selectedPlaylists: this.props.selectedPlaylists ? this.props.selectedPlaylists : [] });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  playlistLoadAction = (playlists) => {
    let canAddToPlaylist = playlists && playlists.length > 0;
    this.setState({ loading: false, canAddToPlaylist: canAddToPlaylist, openCreateNewPlaylist: !canAddToPlaylist ? true : this.state.openCreateNewPlaylist });
  };

  openAddToPlaylist = () => {
    this.setState({ openAddToPlaylist: true });
  };

  openCreateNewPlaylist = () => {
    this.setState({ openCreateNewPlaylist: true });
  };

  cancelCreatePlaylist = () => {
    if (this.state.canAddToPlaylist == false) {
      this.cancelPlaylistModal();
    } else {
      this.setState({ openCreateNewPlaylist: false });
    }
  };

  nextCreatePlaylist = (playlist) => {
    this.setState({ openCreateNewPlaylist: false, canAddToPlaylist: true, selectedPlaylists: [...this.state.selectedPlaylists, playlist] }, () => {
      this.props.nextAction(this.state.selectedPlaylists);
    });
  };

  cancelAddToPlaylist = () => {
    this.setState({ openAddToPlaylist: false });
  };

  nextAddToPlaylist = (playlists) => {
    this.setState({ openAddToPlaylist: false, selectedPlaylists: playlists }, () => {
      this.props.nextAction(this.state.selectedPlaylists);
    });
  };

  cancelPlaylistModal = () => {
    this.props.cancelAction();
  };

  render() {
    let openCreate = this.state.openCreateNewPlaylist || this.state.canAddToPlaylist == false;
    let openAdd = this.state.openAddToPlaylist;
    return (
      <NanoFlex className="playlistModal">
        <PlaylistModalStyle style={openCreate || openAdd ? { display: "none" } : {}}>
          <NanoFlex className="headerModal" justifyContent="flex-start">
            <Playlist />
            <Type.h3>
              <b>{this.translation.playlists.title}</b>
            </Type.h3>
          </NanoFlex>

          {this.state.loading && <Spinner />}
          {!this.state.loading && (
            <NanoFlex className="modalContainer" flexDirection={"column"} justifyContent="space-between" alignContent="space-between">
              <NanoFlex className="modalWrapper" flexDirection={"column"}>
                <NanoFlex className="modalBtnWrapper" onClick={this.openAddToPlaylist}>
                  <Type.h4>{this.translation.playlists.addToPlaylist}</Type.h4>
                </NanoFlex>
                <NanoFlex className="modalBtnWrapper" onClick={this.openCreateNewPlaylist}>
                  <Type.h4>{this.translation.playlists.createNewPlaylist}</Type.h4>
                </NanoFlex>
              </NanoFlex>

              <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
                <Button label={this.translation.geral.cancel} simple clickAction={this.cancelPlaylistModal} />
              </NanoFlex>
            </NanoFlex>
          )}
        </PlaylistModalStyle>
        <NanoFlex style={!openCreate ? { display: "none" } : {}}>
          <CreatePlaylistModal filter={this.props.filter} mode={"Add"} cancelAction={this.cancelCreatePlaylist} nextAction={this.nextCreatePlaylist} />
        </NanoFlex>
        <NanoFlex style={!openAdd ? { display: "none" } : {}}>
          <AddToPlaylistModal selectedPlaylists={this.state.selectedPlaylists} filter={this.props.filter} mode={this.props.mode} playlistLoadAction={this.playlistLoadAction} cancelAction={this.cancelAddToPlaylist} nextAction={this.nextAddToPlaylist} />
        </NanoFlex>
      </NanoFlex>
    );
  }
}

// Set default props
PlaylistModal.defaultProps = {
  cancelAction: () => null,
  nextAction: () => null,
};

export default PlaylistModal;

/*
Doc
import PlaylistModal from '../../Micro/PlaylistModal.js';

<PlaylistModal
    cancelAction={() => console.log('cancelAction')}
    nextAction={() => console.log('nextAction')}
/>
*/
